type SubscriptionVariant = 'all-access' | 'studio-ai'

type SubscriptionLike = {
  id?: string | null
  isTrial?: boolean | null
} | null

type UserDataLike =
  | {
      subscriptionAccess?: {
        allAccess?: {
          subscription?: SubscriptionLike
        }
        studioAi?: {
          subscription?: SubscriptionLike
        }
      }
    }
  | null
  | undefined

export function getSubscriptionToActivate({
  subscriptionType,
  userData,
}: {
  subscriptionType: SubscriptionVariant
  userData: UserDataLike
}) {
  return subscriptionType === 'all-access'
    ? (userData?.subscriptionAccess?.allAccess?.subscription ?? null)
    : (userData?.subscriptionAccess?.studioAi?.subscription ?? null)
}
